export default function (bytes) {
  if (Number.isNaN(bytes)) return 'N/A';

  const megabytes = bytes / (1024 * 1024);
  return `${megabytes.toFixed(2)} MB`;
}
